/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineSaleCommissionCreateModel
 */
export interface MachineSaleCommissionCreateModel {
    /**
     * 
     * @type {number}
     * @memberof MachineSaleCommissionCreateModel
     */
    categoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleCommissionCreateModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleCommissionCreateModel
     */
    priceRate?: number;
}

export function MachineSaleCommissionCreateModelFromJSON(json: any): MachineSaleCommissionCreateModel {
    return MachineSaleCommissionCreateModelFromJSONTyped(json, false);
}

export function MachineSaleCommissionCreateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineSaleCommissionCreateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'priceRate': !exists(json, 'priceRate') ? undefined : json['priceRate'],
    };
}

export function MachineSaleCommissionCreateModelToJSON(value?: MachineSaleCommissionCreateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
        'subCategoryId': value.subCategoryId,
        'priceRate': value.priceRate,
    };
}

